import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {Col, Row, Spinner, Dropdown, Badge, ButtonGroup, Modal} from "react-bootstrap";
import OurDropdown from "../../../primer/Dropdown";
import Button from "react-bootstrap/Button";
import Pagination from "../../../primer/Pagination";
import {
    setBankingTransactionReportUniqueSelection,
    setBankingTransactionsReportRequestData,
    setBankingTransactionsReportResponseData, setBankingTransactionsSelected,
    setHookTransactionModalData,
    setMyConnectedBanks,
    setShowHookTransactionModal
} from "../../../../_reducers/DataPanel/Accounting/accountingSlice";
import {toast} from "react-toastify";
import moment from "moment";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import DateBox from "../../../primer/DateBox";
import {FaDownload} from "react-icons/fa";
import BankTransactionsModal from "./BankTransactionsModal";
import {
    checkPermissionMasterParentStartingTree, getCurrentUser,
    getGreekCurrencyFormat, hookCompanyLogo,
    isEmpty, quickClone
} from "../../../../_helpers/commonFunctions";
import HookTransactionModal from "./HookTransactionModal";
import {fetchAdvancedTypes, fetchBankAccounts} from "../../../../_apis/api";
import Input from "../../../common/Input";
import BootstrapDropdown from "react-bootstrap/Dropdown";
import {jsPDF} from "jspdf";
import {liberationSerif} from "../../../../fonts/liberationSerif";
import {dejavuSans} from "../../../../fonts/DejaVuSans-normal";
import {dejavuSansBold} from "../../../../fonts/DejaVuSans-Bold-bold";
import {autoTable} from "jspdf-autotable";
import * as XLSX from "xlsx";
import Alert from "react-bootstrap/Alert";
import BetterCheckBox from "../../../common/BetterCheckBox";
import {TbLayersDifference} from "react-icons/tb";
import UploadMT940Modal from "./UploadMT940Modal";
import {RiBankFill} from "react-icons/ri";
import {BsEnvelopeFill, BsInfoCircleFill} from "react-icons/bs";
import {FaHistory} from "react-icons/fa";

const AccountingBankingTransactions = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const currentUser = getCurrentUser();
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const myConnectedBanks = useSelector((state) => state.ACCOUNTING_DATA.myConnectedBanks);
    const requestData = useSelector((state) => state.ACCOUNTING_DATA.bankingTransactionsRequestData);
    const responseData = useSelector((state) => state.ACCOUNTING_DATA.bankingTransactionsResponseData);
    const selectedTransactions = useSelector((state) => state.ACCOUNTING_DATA.bankingTransactionsSelectedTransactions);
    const bankingTransactionReportUniqueSelection = useSelector((state) => state.ACCOUNTING_DATA.bankingTransactionReportUniqueSelection);

    const [pageChanged, setPageChanged] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);

    const [showFetchTransactions, setShowFetchTransactions] = useState(false);
    const [loadingEmailSync, setLoadingEmailSync] = useState(false);
    const [showDeccorelateSelections, setShowDeccorelateSelections] = useState(false);
    const [showDeccorelateAndDeleteSelections, setShowDeccorelateAndDeleteSelections] = useState(false);
    const [showMT940Modal, setShowMT940Modal] = useState(false);

    const [loadingDeletables, setLoadingDeletables] = useState(false);
    const [deletables, setDeletables] = useState([]);
    const [acceptDeletion, setAcceptDeletion] = useState(false);

    const [loadingDecorrelate, setLoadingDecorrelate] = useState(false);

    const [scrollToDiff, setScrollToDiff] = useState(false);
    const diffRef = useRef(null);

    const [showLogsModal, setShowLogsModal] = useState(false);
    const [logsData, setLogsData] = useState([]);
    const [loadingLogs, setLoadingLogs] = useState(false);
    const [logsPage, setLogsPage] = useState(1);
    const [logsTotalPages, setLogsTotalPages] = useState(1);

    const [showInfo, setShowInfo] = useState(false);

    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    const statusOptions = [
        {label: "Πλήρως συσχετισμένη", value: "complete"},
        {label: "Μερικώς συσχετισμένη", value: "pending"},
        {label: "Ασυσχέτιστη", value: "empty"},
    ]

    const signOptions = [
        {label: "Προβολή όλων", value: ""},
        {label: "Προβολή χρεώσεων (-)", value: "-"},
        {label: "Προβολή πιστώσεων (+)", value: "+"},
    ]

    const accountOptions = myConnectedBanks.map((o) => {
        return {
            label: o.identifier,
            value: o.accountId,
            iban: o.iban,
            hooked: o.hooked,
        }
    }).filter(Boolean);

    useEffect(() => {
        fetchMyAccounts();
        dispatch(fetchAdvancedTypes({ company: company.id }));
        dispatch(fetchBankAccounts({ company: company.id }));
        if (isEmpty(requestData.date_from) && isEmpty(requestData.date_to)) {
            dispatch(setBankingTransactionsReportRequestData({
                ...requestData,
                date_from: moment(company.year, "YYYY").startOf("year").format("DD/MM/YYYY"),
                date_to: moment(company.year, "YYYY").endOf("year").format("DD/MM/YYYY"),
            }))
        }
    }, [])

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged]);

    useEffect(() => {
        if (showDeccorelateAndDeleteSelections) {
            handleDeccorelateAndDeleteSelections("check");
        } else {
            setDeletables([]);
            setAcceptDeletion(false);
        }
    }, [showDeccorelateAndDeleteSelections])

    const handleOpenInfo = () => setShowInfo(true);
    const handleCloseInfo = () => setShowInfo(false);

    const fetchMyAccounts = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-my-accounts`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                company: company.id,
                includeAll: "true",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                const accs = res.data.data;
                if (accs?.length > 0) {
                    if (accs.length === 1 && isEmpty(requestData.accountId)) {
                        setTimeout(() => {
                            dispatch(setBankingTransactionsReportRequestData({
                                ...requestData,
                                accountId: accs[0].accountId,
                                date_from: moment(company.year, "YYYY").startOf("year").format("DD/MM/YYYY"),
                                date_to: moment(company.year, "YYYY").endOf("year").format("DD/MM/YYYY"),
                            }));
                        }, 100)
                    }
                    dispatch(setMyConnectedBanks(accs));
                }
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchReport = (fromPagination = false) => {
        setLoading(true);
        const reqData = {...requestData};
        if (!fromPagination) {
            reqData.page = 1;
            dispatch(setBankingTransactionsReportRequestData(reqData));
        }
        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-transactions`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                ...reqData,
                company: company.id,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                if (!fromPagination) {
                    if (res.data.data.totalPages > 0) {
                        toast.success("Τα δεδομένα ανανεώθηκαν.", {autoClose: 1000});
                    } else {
                        toast.info("Δεν βρέθηκαν συναλλαγές.", {autoClose: 1000});
                    }
                }
                dispatch(setBankingTransactionsReportResponseData({
                    ...responseData,
                    data: res.data.data.data,
                    totalPages: res.data.data.totalPages,
                    totals: res.data.totals,
                    transactionIds: res.data.transactionIds,
                    differencePage: res.data.differencePage,
                    differenceId: res.data.differenceId,
                }));
                if (res.data.differenceId && scrollToDiff) {
                    setScrollToDiff(false);
                    dispatch(setBankingTransactionReportUniqueSelection(res.data.differenceId));
                    setTimeout(() => {
                        if (diffRef) diffRef.current?.scrollIntoView({behavior: "smooth", container: "nearest"});
                    }, 200)
                }
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const fetchEmailLogs = (page = 1) => {
        setLoadingLogs(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/company/email-banking-logs`, {
            params: {
                company: company.id,
                page: page
            }
        }).then((res) => {
            if (res.data && (res.data.status === "200" || res.data.status === "success")) {
                setLogsData(res.data.data || []);
                setLogsTotalPages(res.data.totalPages || 1);
                setLogsPage(page);
            } else {
                toast.error(res.data.message || "Σφάλμα κατά την άντληση του ιστορικού.");
            }
        }).catch((err) => {
            console.error(err);
            toast.error("Σφάλμα κατά την επικοινωνία με τον server.");
        }).finally(() => {
            setLoadingLogs(false);
        });
    }

    const handleEmailSync = () => {
        setLoadingEmailSync(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/collect-emails`, {user: currentUser._id})
            .then((res) => {
                if (res.data && (res.data.status === "success" || res.data.status === "200")) {
                    const processedCount = res.data.data ? res.data.data.length : 0;

                    if (processedCount > 0) {
                        toast.success(`Ο συγχρονισμός ολοκληρώθηκε! Επεξεργάστηκαν ${processedCount} αρχεία.`);
                        fetchReport(true);
                    } else {
                        toast.info(res.data.message);
                    }
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                console.error(err);
                toast.error("Σφάλμα κατά την επικοινωνία με τον server.");
            })
            .finally(() => {
                setLoadingEmailSync(false);
            });
    }

    const handlePageChange = (page, scrollToDiff = false) => {
        dispatch(setBankingTransactionsReportRequestData({...requestData, page: page}));
        setPageChanged(true);
        if (scrollToDiff) setScrollToDiff(true);
    }

    const handleOnChange = (e, type, name) => {
        const prepChanges = {};
        if (type === "dd") {
            prepChanges[name] = e.value;
        } else if (type === "msdd") {
            prepChanges[name] = e.flatMap((o) => o.value);
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChanges[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChanges[name] = "";
            }
        } else if (type === "input") {
            prepChanges[name] = e.target.value;
        }
        dispatch(setBankingTransactionsReportRequestData({...requestData, ...prepChanges}));
    }

    const handleDocumentAction = (transaction, section) => {
        dispatch(setShowHookTransactionModal(true));
        dispatch(setHookTransactionModalData({
            transaction: transaction,
            section: section,
            documentHooks: transaction?.documentHooks || [],
        }));
    }

    const getDocumentHooksStatus = (status) => {
        if (status === "complete") {
            return (
                <div style={{lineHeight: "20px"}}>
                    <span style={{ color: "green", marginRight: "4px" }}>◉</span>
                    <span>Πλήρως συσχετισμένη</span>
                </div>
            )
        } else if (status === "pending") {
            return (
                <div style={{lineHeight: "20px"}}>
                    <span style={{ color: "#ccc610", marginRight: "4px" }}>◉</span>
                    <span>Μερικώς συσχετισμένη</span>
                </div>
            )
        } else if (status === "empty" || isEmpty(status)) {
            return (
                <div style={{lineHeight: "20px"}}>
                    <span style={{ color: "red", marginRight: "4px" }}>◉</span>
                    <span>Ασυσχέτιστη</span>
                </div>
            )
        }
        return status;
    }

    const handlePDFExport = async () => {
        setLoadingExport(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-transactions`, {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    ...requestData,
                    page: -1,
                    company: company.id,
                }
            })
            if (response.data.status === "200") {
                const resData = quickClone(response.data.data.data).reverse();
                let rows = [];
                const headerColumns = ["Περιγραφή Συναλλαγής", "Ημερομηνία Πράξης", "Ημερομηνία Αξίας", "Ποσό πράξης", "Υπόλοιπο Όψεως", "Υπόλοιπο Λογιστικού Λογαριασμού"];
                for (const transaction of resData) {
                    rows.push([
                        String(transaction["erp_description"]).replaceAll("\n", " "),
                        moment(transaction["bookingDate"]).format("DD/MM/YYYY"),
                        moment(transaction["valueDate"]).format("DD/MM/YYYY"),
                        getGreekCurrencyFormat(transaction.transactionAmount),
                        getGreekCurrencyFormat(transaction["runningBalance"] || 0),
                        transaction["accountingBalance"] === "-" ? ">>" : getGreekCurrencyFormat(transaction["accountingBalance"] || 0),
                    ])
                }
                rows.push([
                    {content: "Σύνολο Χρεώσεων", colSpan: 5, styles: {halign: "right"}},
                    getGreekCurrencyFormat(responseData.totals.totalDebit),
                ])
                rows.push([
                    {content: "Σύνολο Πιστώσεων", colSpan: 5, styles: {halign: "right"}},
                    getGreekCurrencyFormat(responseData.totals.totalCredit),
                ])
                rows.push([
                    {content: "Λογιστικό Αποτέλεσμα", colSpan: 5, styles: {halign: "right"}},
                    getGreekCurrencyFormat(responseData.totals.totalSum),
                ])

                const doc = new jsPDF('landscape');
                let y = 23;

                doc.addFileToVFS("arialuni.ttf", liberationSerif);
                doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");

                hookCompanyLogo(doc, companyDetails);

                const imgData = 'assets/images/prrimer-logo.png';
                const primerWidth = 28;
                const primerHeight = 10;
                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();
                doc.addImage(imgData, 'PNG', pageWidth - primerWidth - 10, pageHeight - primerHeight - 5, primerWidth, primerHeight);
                doc.setFont("DejaVu Sans Bold");
                doc.setFontSize(10);
                const header = doc.splitTextToSize(`Τραπεζικές συναλλαγές περιόδου ${requestData.date_from} - ${requestData.date_to}`, 200);
                const headerString = header.join("\n");
                doc.text(headerString, doc.internal.pageSize.getWidth() / 4, 9, {alignment: "center"});

                doc.setFont("DejaVu Sans Normal");
                doc.setFontSize(9);
                doc.text(`Τραπεζικός Λογαριασμός: ${selectedBank.label}`, 15, 14, {alignment: "center"});
                doc.text(`${company.name}, ΑΦΜ: ${company.vatNumber}`, 15, 18, {alignment: "center"});
                doc.text(`ΔΟΥ: ${companyDetails.doy}`, 15, 22, {alignment: "center"});
                doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY")}`, 190, 21, {alignment: "center"});

                autoTable(doc, {
                    startY: y,
                    head: [headerColumns],
                    body: rows,
                    rowPageBreak: "avoid",
                    styles: {
                        font: "DejaVu Sans Normal",
                        fontStyle: "normal",
                        fontSize: 8,
                        halign: "center",
                    },
                })

                const pageCount = doc.getNumberOfPages();
                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.setFontSize(10);
                    doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                }

                doc.save(`Τραπεζικές συναλλαγές.pdf`);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error("Σφάλμα κατά την άντληση δεδομένων.");
        }
        setLoadingExport(false);
    }

    const handleExcelExport = async () => {
        setLoadingExport(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-transactions`, {
                headers: {'Content-Type': 'application/json'},
                params: {
                    ...requestData,
                    page: -1,
                    company: company.id,
                }
            })
            if (response.data.status === "200") {
                const resData = quickClone(response.data.data.data).reverse();
                const rows = [];
                rows.push(["Επωνυμία:", company.name]);
                rows.push(["ΑΦΜ:", company.vatNumber]);
                rows.push(["ΔΟΥ:", companyDetails.doy]);
                rows.push([`Εύρος ημερομηνίας:`, `${requestData.date_from} - ${requestData.date_to}`]);
                rows.push([`Ημερομηνία Εξαγωγής:`, `${moment().format("DD/MM/YYYY HH:mm:ss")}`]);
                rows.push([`Τραπεζικός Λογαριασμός:`, selectedBank.label]);
                rows.push([]);

                const headerColumns = ["Περιγραφή Συναλλαγής", "Ημερομηνία Πράξης", "Ημερομηνία Αξίας", "Ποσό πράξης", "Υπόλοιπο Όψεως", "Υπόλοιπο Λογιστικού Λογαριασμού"];
                rows.push(headerColumns);
                for (const transaction of resData) {
                    rows.push([
                        String(transaction["erp_description"]).replaceAll("\n", " "),
                        moment(transaction["bookingDate"]).format("DD/MM/YYYY"),
                        moment(transaction["valueDate"]).format("DD/MM/YYYY"),
                        getGreekCurrencyFormat(transaction.transactionAmount),
                        getGreekCurrencyFormat(transaction["runningBalance"] || 0),
                        transaction["accountingBalance"] === "-" ? ">>" : getGreekCurrencyFormat(transaction["accountingBalance"] || 0),
                    ])
                }
                const workSheet = XLSX.utils.aoa_to_sheet(rows);
                const workBook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workBook, workSheet, "Τραπεζικές Συναλλαγές");
                XLSX.writeFile(workBook, 'Τραπεζικές Συναλλαγές.xlsx');
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error("Σφάλμα κατά την άντληση δεδομένων.");
        }
        setLoadingExport(false);
    }

    const toggleSelectAll = () => {
        if (responseData?.transactionIds?.length === selectedTransactions.length) {
            dispatch(setBankingTransactionsSelected([]));
        } else {
            dispatch(setBankingTransactionsSelected(responseData.transactionIds));
        }
    }

    const toggleSelection = (id) => {
        if (selectedTransactions.includes(id)) {
            dispatch(setBankingTransactionsSelected(selectedTransactions.filter((el) => el !== id)));
        } else {
            dispatch(setBankingTransactionsSelected([...selectedTransactions, id]));
        }
    }

    const clearSelections = () => {
        dispatch(setBankingTransactionsSelected([]));
    }

    const handleDeccorelateSelections = () => {
        setLoadingDecorrelate(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/banking-decorrelate-selections`, {
            company: company.id,
            transactionIds: selectedTransactions,
        }).then((res) => {
            if (res.data.status === "200") {
                setShowDeccorelateSelections(false);
                toast.success("Επιτυχής ενέργεια.");
                fetchReport(true);
            } else {
                toast.error(res.data.message);
            }
            setLoadingDecorrelate(false);
        }).catch((err) => {
            setLoadingDecorrelate(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleDeccorelateAndDeleteSelections = (callType = "check") => {
        if (callType === "attempt") setLoadingDecorrelate(true);
        if (callType === "check") {
            setLoadingDeletables(true);
            setDeletables([]);
        }
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/banking-decorrelate-delete-selections`, {
            company: company.id,
            transactionIds: selectedTransactions,
            callType: callType,
        }).then((res) => {
            if (res.data.status === "200") {
                if (callType === "attempt") {
                    setShowDeccorelateAndDeleteSelections(false);
                    toast.success("Επιτυχής ενέργεια.");
                    fetchReport(true);
                } else if (callType === "check") {
                    setDeletables(res.data.data);
                }
            } else {
                toast.error(res.data.message);
            }
            if (callType === "attempt") setLoadingDecorrelate(false);
            if (callType === "check") setLoadingDeletables(false);
        }).catch((err) => {
            if (callType === "attempt") setLoadingDecorrelate(false);
            if (callType === "check") setLoadingDeletables(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const hasSelectedBank = !isEmpty(requestData.accountId);
    const selectedBank = hasSelectedBank ? accountOptions.find((el) => requestData.accountId === el.value) : null;

    const renderLogDetails = (detailsStr) => {
        if (!detailsStr) return "-";
        if (!detailsStr.includes(" | ")) return <span>{detailsStr}</span>;
        if (!detailsStr.includes(" | ")) return <div style={{ textAlign: "center" }}>{detailsStr}</div>;

        const parts = detailsStr.split(" | ");
        const dataMap = {};
        parts.forEach(p => {
            const splitIdx = p.indexOf(":");
            if (splitIdx !== -1) {
                dataMap[p.substring(0, splitIdx).trim()] = p.substring(splitIdx + 1).trim();
            }
        });

        const newCount = parseInt(dataMap["Νέες"]) || 0;
        const updatedCount = parseInt(dataMap["Ενημερώθηκαν"]) || 0;

        return (
            <div style={{ lineHeight: "1.5" }}>
                <div style={{ fontWeight: "500", color: "#333", display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
                    <span>
                        Σύνολο: {dataMap["Σύνολο Συναλλαγών"] || "0"}
                        <span style={{ margin: "0 6px", color: "#ccc" }}>•</span>
                        Νέες: <span style={{ color: newCount > 0 ? "#76aeb7" : "inherit", fontWeight: newCount > 0 ? "bold" : "normal" }}>{newCount}</span>
                        <span style={{ margin: "0 6px", color: "#ccc" }}>•</span>
                        Ενημερώθηκαν: <span style={{ color: updatedCount > 0 ? "#fd7e14" : "inherit", fontWeight: updatedCount > 0 ? "bold" : "normal" }}>{updatedCount}</span>
                    </span>
                    {dataMap["Ημ/νίες"] && (
                        <span style={{ marginLeft: "11px", marginTop: "2px", fontSize: "11px", color: "#76aeb7", backgroundColor: "#f1fdff", padding: "2px 6px", borderRadius: "4px" }}>
                            {dataMap["Ημ/νίες"]}
                        </span>
                    )}
                </div>

                <div style={{ color: "#6c757d", fontSize: "12px", justifyContent: "center", marginTop: "4px" }}>
                    {dataMap["Αρχείο"] && <span><i className="fa fa-file fa-sm"></i> {dataMap["Αρχείο"]}</span>}
                    {dataMap["Τράπεζα"] && <span style={{ marginLeft: "12px" }}><i className="fa-solid fa-building-columns fa-sm"></i> {dataMap["Τράπεζα"]} {dataMap["IBAN Λογαριασμού"] ? `(${dataMap["IBAN Λογαριασμού"]})` : ""}</span>}
                    {dataMap["Αποστολέας"] && <span style={{ marginLeft: "12px" }}><i className="fa-solid fa-envelope fa-sm"></i> {dataMap["Αποστολέας"]}</span>}
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className={"mb-3 product-form position-relative"} onClick={() => {
                if (bankingTransactionReportUniqueSelection) dispatch(setBankingTransactionReportUniqueSelection(""));
            }}>
                {!hasSelectedBank && <div className="overlay_w">Παρακαλώ επιλέξτε έναν τραπεζικό λογαριασμό</div>}
                <div onKeyDown={(e) => {
                    if (e.key === "Enter") fetchReport(false);
                }}>

                    {companyDetails.automaticBankTransactionsEmailFetching ? (
                        <React.Fragment>
                            <Row className={"mb-2"}>
                                <Col md={4} className={"showWithOverlay"}>
                                    <OurDropdown name={"accountId"} label={"Τραπεζικός Λογαριασμός"} className={"mb-0"} options={accountOptions} required={true} defaultValue={selectedBank} onChange={(e) => handleOnChange(e, "dd", "accountId")} />
                                </Col>
                                <Col md={2}>
                                    {hasSelectedBank && selectedBank?.hooked === true ? (
                                        <ButtonGroup>
                                            <Button onClick={() => setShowFetchTransactions(true)} style={{padding: "10px", marginTop: "10px"}}>
                                                <FaDownload /> Άντληση Συναλλαγών
                                            </Button>
                                            <Button onClick={() => setShowMT940Modal(true)} style={{padding: "10px", marginTop: "10px"}}>
                                                <RiBankFill /> Εισαγωγή Συναλλαγών από MT940
                                            </Button>
                                        </ButtonGroup>
                                    ) : (
                                        <Button
                                            onClick={() => setShowMT940Modal(true)}
                                            style={{
                                                marginTop: "23px",
                                                width: "100%",
                                                minHeight: "54px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: "10px",
                                            }}
                                        >
                                            <RiBankFill className="mr-1" style={{ fontSize: '1.5rem' }} /> Εισαγωγή Συναλλαγών από MT940
                                        </Button>
                                    )}
                                </Col>
                                <Col md={3}>
                                    <ButtonGroup style={{ marginTop: "23px", width: "100%" }}>
                                        <Button
                                            onClick={handleEmailSync}
                                            disabled={loadingEmailSync}
                                            style={{
                                                width: "100%",
                                                minHeight: "57px",
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 0,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: "10px",
                                            }}
                                        >
                                            <BsEnvelopeFill className="mr-1" style={{ fontSize: '1rem' }} /> Έλεγχος Συναλλαγών από Email
                                            {loadingEmailSync &&
                                                <Spinner className={"ml-2"} animation={"border"} size={"sm"} variant={"light"}/>
                                            }
                                        </Button>
                                        <Button
                                            onClick={handleOpenInfo}
                                            style={{
                                                marginTop: "0px",
                                                borderTopLeftRadius: 0,
                                                borderBottomLeftRadius: 0,
                                                borderLeft: "1px solid rgba(255, 255, 255, 0.15)",
                                                minWidth: "54px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 0
                                            }}
                                            title="Οδηγίες ελέγχου συναλλαγών από Email"
                                        >
                                            <BsInfoCircleFill style={{ fontSize: '1rem' }}/>
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                                <Col md={2}>
                                    <Button
                                        style={{
                                            marginTop: "23px",
                                            width: "100%",
                                            minHeight: "57px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}
                                        onClick={() => { setShowLogsModal(true); fetchEmailLogs(1); }}
                                    >
                                        <FaHistory className={"mr-1"} style={{ fontSize: '1rem' }} /> Αρχείο Καταγραφής
                                    </Button>
                                </Col>
                            </Row>
                            <Row className={"mb-2"}>
                                <Col md={2}>
                                    <DateHelper dateFromAndToFunction={(from, to) => dispatch(setBankingTransactionsReportRequestData({...requestData, date_from: from, date_to: to}))} />
                                </Col>
                                <Col md={2}>
                                    <DateBox name="date_from" selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : ""} label={"Ημερομηνία από"} onChange={(e) => handleOnChange(e, "datebox", "date_from")} />
                                </Col>
                                <Col md={2}>
                                    <DateBox name="date_to" selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : ""} label={"Ημερομηνία έως"} onChange={(e) => handleOnChange(e, "datebox", "date_to")} />
                                </Col>
                            </Row>
                            <Row className={"mb-2"}>
                                <Col md={4}>
                                    <Input name={"description"} type={"text"} label={"Περιγραφή Συναλλαγής"} value={requestData.description} autoComplete={"off"} onChange={(e) => handleOnChange(e, "input", "description")} />
                                </Col>
                                <Col md={2}>
                                    <Input name={"amount_from"} type={"number"} label={"Ποσό από"} value={requestData.amount_from} autoComplete={"off"} onChange={(e) => handleOnChange(e, "input", "amount_from")} />
                                </Col>
                                <Col md={2}>
                                    <Input name={"amount_to"} type={"number"} label={"Ποσό έως"} value={requestData.amount_to} autoComplete={"off"} onChange={(e) => handleOnChange(e, "input", "amount_to")} />
                                </Col>
                                <Col md={2}>
                                    <OurDropdown name={"status"} label={"Κατάσταση Συναλλαγής"} options={statusOptions} multiSelect={true} defaultValue={statusOptions.filter((el) => requestData.status.includes(el.value))} onChange={(e) => handleOnChange(e, "msdd", "status")} />
                                </Col>
                                <Col md={2}>
                                    <OurDropdown name={"sign"} label={"Πρόσημο Συναλλαγής"} options={signOptions} defaultValue={signOptions.filter((el) => el.value === requestData.sign)} onChange={(e) => handleOnChange(e, "dd", "sign")} />
                                </Col>
                            </Row>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <Row className={"mb-2"}>
                                <Col md={4} className={"showWithOverlay"}>
                                    <OurDropdown name={"accountId"} label={"Τραπεζικός Λογαριασμός"} className={"mb-0"} options={accountOptions} required={true} defaultValue={selectedBank} onChange={(e) => handleOnChange(e, "dd", "accountId")} />
                                </Col>
                                <Col md={2}>
                                    {hasSelectedBank && selectedBank?.hooked === true ? (
                                        <Button onClick={() => setShowFetchTransactions(true)} style={{marginTop: "23px"}}><FaDownload className="mr-1" /> Άντληση Συναλλαγών</Button>
                                    ) : (
                                        <Button onClick={() => setShowMT940Modal(true)} style={{marginTop: "14px"}}><RiBankFill className="mr-1" /> Εισαγωγή Συναλλαγών από MT940</Button>
                                    )}
                                </Col>
                                <Col md={2}>
                                    <DateHelper dateFromAndToFunction={(from, to) => dispatch(setBankingTransactionsReportRequestData({...requestData, date_from: from, date_to: to}))} />
                                </Col>
                                <Col md={2}>
                                    <DateBox name="date_from" selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : ""} label={"Ημερομηνία από"} onChange={(e) => handleOnChange(e, "datebox", "date_from")} />
                                </Col>
                                <Col md={2}>
                                    <DateBox name="date_to" selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : ""} label={"Ημερομηνία έως"} onChange={(e) => handleOnChange(e, "datebox", "date_to")} />
                                </Col>
                            </Row>
                            <Row className={"mb-2"}>
                                <Col md={4}>
                                    <Input name={"description"} type={"text"} label={"Περιγραφή Συναλλαγής"} value={requestData.description} autoComplete={"off"} onChange={(e) => handleOnChange(e, "input", "description")} />
                                </Col>
                                <Col md={2}>
                                    <Input name={"amount_from"} type={"number"} label={"Ποσό από"} value={requestData.amount_from} autoComplete={"off"} onChange={(e) => handleOnChange(e, "input", "amount_from")} />
                                </Col>
                                <Col md={2}>
                                    <Input name={"amount_to"} type={"number"} label={"Ποσό έως"} value={requestData.amount_to} autoComplete={"off"} onChange={(e) => handleOnChange(e, "input", "amount_to")} />
                                </Col>
                                <Col md={2}>
                                    <OurDropdown name={"status"} label={"Κατάσταση Συναλλαγής"} options={statusOptions} multiSelect={true} defaultValue={statusOptions.filter((el) => requestData.status.includes(el.value))} onChange={(e) => handleOnChange(e, "msdd", "status")} />
                                </Col>
                                <Col md={2}>
                                    <OurDropdown name={"sign"} label={"Πρόσημο Συναλλαγής"} options={signOptions} defaultValue={signOptions.filter((el) => el.value === requestData.sign)} onChange={(e) => handleOnChange(e, "dd", "sign")} />
                                </Col>
                            </Row>
                        </React.Fragment>
                    )}

                    <Row className={"d-flex justify-content-end"}>
                        <Col md={2} className={"d-flex justify-content-end"}>
                            <Button onClick={() => fetchReport(false)} disabled={loading} style={{height: "36px", lineHeight: "8px", width: "100%"}}>
                                Αναζήτηση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                            </Button>
                        </Col>
                    </Row>
                </div>
                {(responseData.totalPages > 0 && hasSelectedBank) && (
                    <React.Fragment>
                        <Row className={"mt-2"}>
                            <Col md={6}>
                                {selectedTransactions.length > 0 && (
                                    <div className={"mb-1"}>
                                        <i>Επιλεγμένες συναλλαγές {selectedTransactions.length} / {responseData?.transactionIds?.length || 0}</i>
                                        <ButtonGroup size={"sm"} className={"ml-2"} style={{height: "36px", lineHeight: "8px"}}>
                                            <Button onClick={() => clearSelections()}>Αποεπιλογή</Button>
                                            <Button onClick={() => setShowDeccorelateSelections(true)}>Αποσυσχέτιση</Button>
                                            <Button onClick={() => setShowDeccorelateAndDeleteSelections(true)} variant={"outline-danger"}>Αποσυσχέτιση & Διαγραφή</Button>
                                        </ButtonGroup>
                                    </div>
                                )}
                                {(!isEmpty(requestData.description) || !isEmpty(requestData.amount_from) || !isEmpty(requestData.amount_to) || requestData.status?.length > 0 || requestData.sign) && (
                                    <span><strong>(*) Προσοχή:</strong> Ενδέχεται λόγω των φίλτρων να μην προκύπτει σωστά το ποσό στη στήλη "Υπόλοιπο Λογιστικού Λογαριασμού"<br/></span>
                                )}
                                {responseData.data.some((el) => isEmpty(el.difference)) && (
                                    <span>(*) Ο παρόν τραπεζικός λογαριασμός δεν έχει συνδεδεμένο λογιστικό λογαριασμό.<br/></span>
                                )}
                            </Col>
                            <Col md={6} className={"d-flex justify-content-end"}>
                                {(responseData.differencePage > 0) && (
                                    <Badge bg={"primary"} className={"mr-2 mb-3"}
                                           style={{alignSelf: "center", padding: "2px", cursor: "pointer"}}
                                           title={"Προς σελίδα εκκίνησης διαφοράς Όψεως - Λογ. Λογαριασμού"}
                                           onClick={() => handlePageChange(responseData.differencePage, true)}
                                    >
                                        <TbLayersDifference size={26}/>
                                    </Badge>
                                )}
                                <Pagination
                                    currentPage={requestData.page}
                                    totalPages={responseData.totalPages}
                                    handlePageChange={(page) => handlePageChange(page)}
                                />
                            </Col>
                        </Row>
                        <Row className={"mt-2"}>
                            <Col md={12}>
                                <table className={"simpleClassicTable"} style={{fontSize: "12px"}}>
                                    <colgroup>
                                        <col span={1} style={{width: "3%"}}></col>
                                        <col span={1} style={{width: "37%"}}></col>
                                        <col span={1} style={{width: "7.5%"}}></col>
                                        <col span={1} style={{width: "7.5%"}}></col>
                                        <col span={1} style={{width: "7.5%"}}></col>
                                        <col span={1} style={{width: "7.5%"}}></col>
                                        <col span={1} style={{width: "10%"}}></col>
                                        <col span={1} style={{width: "10%"}}></col>
                                        <col span={1} style={{width: "10%"}}></col>
                                    </colgroup>
                                    <thead>
                                    <tr>
                                        <th style={{zoom: "1.3"}}>
                                            <input
                                                style={{cursor: "pointer"}}
                                                type={"checkbox"}
                                                title={"Επιλογή όλων"}
                                                checked={selectedTransactions.length === responseData?.transactionIds?.length}
                                                onChange={() => toggleSelectAll()}
                                            />
                                        </th>
                                        <th>Περιγραφή Συναλλαγής</th>
                                        <th>Ημερομηνία Πράξης</th>
                                        <th>Ημερομηνία Αξίας</th>
                                        <th>Ποσό πράξης</th>
                                        <th>Υπόλοιπο Όψεως</th>
                                        <th>Υπόλοιπο Λογιστικού Λογαριασμού</th>
                                        <th>Κατάσταση</th>
                                        <th>Εγγραφή</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {responseData.data.map((transaction, idx) => (
                                        <tr
                                            key={`aba-${idx}`}
                                            style={{backgroundColor: bankingTransactionReportUniqueSelection === transaction._id ? "lightblue" : ""}}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                dispatch(setBankingTransactionReportUniqueSelection(transaction._id));
                                            }}
                                            onDoubleClick={(e) => {
                                                e.stopPropagation();
                                                if (+transaction.transactionAmount > 0) {
                                                    handleDocumentAction(transaction, "Client Payments");
                                                } else {
                                                    handleDocumentAction(transaction, "Supplier Payments")
                                                }
                                            }}
                                            ref={transaction._id === responseData.differenceId ? diffRef : null}
                                        >
                                            <td style={{zoom: "1.3"}}>
                                                <input
                                                    style={{cursor: "pointer"}}
                                                    type={"checkbox"}
                                                    title={"Επιλογή"}
                                                    checked={selectedTransactions.includes(transaction._id)}
                                                    onChange={() => toggleSelection(transaction._id)}
                                                />
                                            </td>
                                            <td>{transaction["erp_description"]}</td>
                                            <td>{moment(transaction["bookingDate"]).format("DD/MM/YYYY")}</td>
                                            <td>{moment(transaction["valueDate"]).format("DD/MM/YYYY")}</td>
                                            <td>{getGreekCurrencyFormat(transaction.transactionAmount)}</td>
                                            <td>{getGreekCurrencyFormat(transaction["runningBalance"] || 0)}</td>
                                            <td style={{backgroundColor: isEmpty(transaction.difference) ? "lightgray" : transaction.difference === true ? "#f79292" : "lightgreen"}}>
                                                {transaction["accountingBalance"] === "-" ? ">>" : getGreekCurrencyFormat(transaction["accountingBalance"] || 0)}
                                            </td>
                                            <td>{getDocumentHooksStatus(transaction["documentHooksStatus"])}</td>
                                            <td style={{padding: "2px"}}>
                                                <Dropdown direction={"start"} drop={"start"}>
                                                    <Dropdown.Toggle variant={"primary"} size={"sm"} style={{flex: "1", width: "100%"}}>
                                                        Εγγραφή
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu style={{
                                                        marginRight: "3px",
                                                        borderRadius: "8px",
                                                        border: "2px solid #d9d7d7",
                                                        boxShadow: "rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px",
                                                        padding: "0px",
                                                        overflow: "hidden",
                                                        textAlign: "center",
                                                    }}>
                                                        <Dropdown.Item onClick={() => handleDocumentAction(transaction, "Client Payments")}>Είσπραξης</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => handleDocumentAction(transaction, "Sales")}>Πώλησης</Dropdown.Item>
                                                        {checkPermissionMasterParentStartingTree("buys", permissionsData) === true && (
                                                            <React.Fragment>
                                                                <Dropdown.Item onClick={() => handleDocumentAction(transaction, "Supplier Payments")}>Πληρωμής</Dropdown.Item>
                                                                <Dropdown.Item onClick={() => handleDocumentAction(transaction, "Buys")}>Αγοράς</Dropdown.Item>
                                                            </React.Fragment>
                                                        )}
                                                        {checkPermissionMasterParentStartingTree("accounting", permissionsData) === true && (
                                                            <Dropdown.Item onClick={() => handleDocumentAction(transaction, "Accounting Records")}>Λογιστικής</Dropdown.Item>
                                                        )}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                        <Row className={"mt-2"}>
                            <Col md={7}>
                                <BootstrapDropdown className="mb-3 mt-3">
                                    <BootstrapDropdown.Toggle variant="primary" id="dropdown-basic" disabled={loadingExport}>
                                        Αποθήκευση αποτελεσμάτων {loadingExport && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} size="sm" />}
                                    </BootstrapDropdown.Toggle>
                                    <BootstrapDropdown.Menu>
                                        <BootstrapDropdown.Item onClick={() => handlePDFExport()}>
                                            Αποθήκευση ως PDF
                                        </BootstrapDropdown.Item>
                                        <BootstrapDropdown.Item onClick={() => handleExcelExport()}>
                                            Αποθήκευση ως XLSX
                                        </BootstrapDropdown.Item>
                                    </BootstrapDropdown.Menu>
                                </BootstrapDropdown>
                            </Col>
                            <Col md={5}>
                                {responseData.totals && (
                                    <table className={"simpleClassicTable"} style={{fontSize: "16px", fontWeight: "600"}}>
                                        <thead>
                                        <tr>
                                            <th colSpan={2}>Σύνολα</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>Πλήθος Συναλλαγών</td>
                                            <td>
                                                {responseData.totals.totalCount}
                                                <Badge bg={"success"} style={{fontSize: "16px"}} className={"ml-2 p-1"} title={"Συσχετισμένες"}>{responseData.totals.countComplete}</Badge>
                                                <Badge bg={"warning"} style={{fontSize: "16px"}} className={"ml-2 p-1"} title={"Μερικώς Συσχετισμένες"}>{responseData.totals.countPending}</Badge>
                                                <Badge bg={"danger"} style={{fontSize: "16px"}} className={"ml-2 p-1"} title={"Ασυσχέτιστες"}>{responseData.totals.countEmpty}</Badge>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Σύνολο Χρεώσεων</td>
                                            <td>{getGreekCurrencyFormat(responseData.totals.totalDebit)}</td>
                                        </tr>
                                        <tr>
                                            <td>Σύνολο Πιστώσεων</td>
                                            <td>{getGreekCurrencyFormat(responseData.totals.totalCredit)}</td>
                                        </tr>
                                        <tr>
                                            <td>Λογιστικό Αποτέλεσμα</td>
                                            <td>{getGreekCurrencyFormat(responseData.totals.totalSum)}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                )}
                            </Col>
                        </Row>
                    </React.Fragment>
                )}
            </div>
            <BankTransactionsModal
                show={showFetchTransactions}
                setShow={setShowFetchTransactions}
                selectedBank={selectedBank}
            />
            <HookTransactionModal
                callback={() => fetchReport(true)}
            />
            <UploadMT940Modal
                show={showMT940Modal}
                setShow={setShowMT940Modal}
                selectedBank={selectedBank}
            />

            <Modal show={showDeccorelateSelections} onHide={() => setShowDeccorelateSelections(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Αποσυσχέτιση επιλεγμένων</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Είσαστε σίγουροι ότι θέλετε να αποσυσχετίσετε τις επιλεγμένες συναλλαγές από τις εγγραφές τους;
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={loadingDecorrelate} variant="primary" onClick={() => handleDeccorelateSelections()}>
                        Ναι, αποσυσχέτιση {loadingDecorrelate && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeccorelateAndDeleteSelections} onHide={() => setShowDeccorelateAndDeleteSelections(false)} backdrop={"static"} dialogClassName={"modal42PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Αποσυσχέτιση & Διαγραφή επιλεγμένων</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingDeletables ? (
                        <div style={{textAlign: "center"}}>Παρακαλώ περιμένετε...</div>
                    ) : (
                        <div>
                            {deletables.length === 0 ? (
                                <span>Δεν βρέθηκαν εγγραφές προς αποσυσχέτιση και διαγραφή.</span>
                            ) : (
                                <React.Fragment>
                                    <Alert variant={"danger"}>
                                        <strong>Προσοχή:</strong> Κατά την διαγραφή εμπορικών εγγραφών θα διαγραφούν και οι αντίστοιχες γεφυρωμένες λογιστικές εγγραφές.
                                        Θα διαγραφούν μόνο οι εγγραφές που στον πίνακα αναγράφονται ως διαγράψιμες.
                                    </Alert>
                                    <table className={"simpleClassicTable"}>
                                        <colgroup>
                                            <col span={1} style={{width: "40%"}}></col>
                                            <col span={1} style={{width: "20%"}}></col>
                                            <col span={1} style={{width: "40%"}}></col>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>Εγγραφή</th>
                                            <th>Διαγράψιμη</th>
                                            <th>Πληροφορίες</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {deletables.map((row, idx) => (
                                            <tr key={`deletables-${idx}`} style={{backgroundColor: row.deletable === false ? "#f79292" : ""}}>
                                                <td>{row["label"]}</td>
                                                <td>{row["deletable"] === true ? "Ναι" : "Όχι"}</td>
                                                <td>{row["deletableMessage"]}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </React.Fragment>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <BetterCheckBox
                        name={"acceptDeletion"}
                        className={"mt-2"}
                        text={<span>Αποδέχομαι την βαρύτητα της ενέργειας <span style={{color: "red"}}>(*)</span></span>}
                        checked={acceptDeletion}
                        disabled={loadingDecorrelate || loadingDeletables || !deletables.some((el) => el.deletable)}
                        required={true}
                        onChange={(e) => setAcceptDeletion(e.target.checked)}
                    />
                    <Button disabled={loadingDecorrelate || loadingDeletables || !deletables.some((el) => el.deletable) || !acceptDeletion} variant="primary" onClick={() => handleDeccorelateAndDeleteSelections("attempt")}>
                        Αποσυσχέτιση & Διαγραφή {loadingDecorrelate && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showLogsModal} onHide={() => setShowLogsModal(false)} dialogClassName={"modal65PercentWidth"} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Ιστορικό Αυτόματου Συγχρονισμού Μέσω Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingLogs ? (
                        <div style={{textAlign: "center", padding: "30px"}}>
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <React.Fragment>
                            {logsTotalPages > 1 && (
                                <div className={"d-flex justify-content-end"}>
                                    <Pagination
                                        currentPage={logsPage}
                                        totalPages={logsTotalPages}
                                        handlePageChange={(page) => fetchEmailLogs(page)}
                                    />
                                </div>
                            )}
                            <table className={"simpleClassicTable"}>
                                <colgroup>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "20%"}}></col>
                                    <col span={1} style={{width: "65%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Ημερομηνία & Ώρα</th>
                                    <th>Εκτέλεση Από</th>
                                    <th>Λεπτομέρειες</th>
                                </tr>
                                </thead>
                                <tbody>
                                {logsData.length > 0 ? (
                                    logsData.map((log, idx) => (
                                        <tr key={`log-${idx}`}>
                                            <td>{moment(log.created_at).format("DD/MM/YYYY HH:mm:ss")}</td>
                                            <td>
                                                {log.user === "System Automations (CRON)" ? (
                                                    <Badge bg="secondary">System Automations (CRON)</Badge>
                                                ) : (
                                                    <Badge bg="primary">{log.user}</Badge>
                                                )}
                                            </td>
                                            <td>
                                                {renderLogDetails(log.fieldsChanged)}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={3} style={{textAlign: "center", padding: "5px", backgroundColor: "#ecf0f5"}}>
                                            Δεν βρέθηκαν καταγραφές.
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </React.Fragment>
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={showInfo} onHide={handleCloseInfo} dialogClassName={"modal45PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Οδηγίες Ελέγχου Συναλλαγών από Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-3">
                        Για την επιτυχή λήψη και επεξεργασία των τραπεζικών σας δεδομένων από την εφαρμογή, παρακαλούμε όπως ακολουθήσετε τα παρακάτω βήματα στο περιβάλλον της τράπεζάς σας:
                    </p>

                    <ul style={{ listStyle: "none", paddingLeft: "5px" }}>
                        <li className="mb-3 d-flex align-items-start">
                            <span className="text-primary mr-2" style={{ fontSize: "1.1rem", lineHeight: "1" }}>•</span>
                            <div>
                                <strong>Σύνδεση στην υπηρεσία:</strong> Πραγματοποιήστε είσοδο (Login) στην επίσημη πλατφόρμα <strong>Web Banking</strong> της συμβεβλημένης τράπεζάς σας.
                            </div>
                        </li>
                        <li className="mb-3 d-flex align-items-start">
                            <span className="text-primary mr-2" style={{ fontSize: "1.1rem", lineHeight: "1" }}>•</span>
                            <div>
                                <strong>Εντοπισμός της υπηρεσίας:</strong> Πλοηγηθείτε στο κεντρικό μενού και επιλέξτε την ενότητα <strong>«Αποστολή κινήσεων με Email»</strong> (ή την αντίστοιχη ονομασία που χρησιμοποιεί το ίδρυμά σας για την εξαγωγή κινήσεων).
                            </div>
                        </li>
                        <li className="mb-3 d-flex align-items-start">
                            <span className="text-primary mr-2" style={{ fontSize: "1.1rem", lineHeight: "1" }}>•</span>
                            <div>
                                <strong>Ορισμός τύπου αρχείου:</strong> Στο πεδίο μορφοποίησης, επιλέξτε ως τύπο αρχείου εξαγωγής το πρότυπο <strong>MT940</strong>.
                            </div>
                        </li>
                        <li className="mb-3 d-flex align-items-start">
                            <span className="text-primary mr-2" style={{ fontSize: "1.1rem", lineHeight: "1" }}>•</span>
                            <div>
                                <strong>Καταχώριση email λήψης:</strong> Ορίστε ως διεύθυνση ηλεκτρονικού ταχυδρομείου (Email) στην οποία θα αποστέλλονται οι κινήσεις του λογαριασμού σας το Email: <strong>bankstatements@primer.gr</strong>.
                            </div>
                        </li>
                        <li className="mb-3 d-flex align-items-start">
                            <span className="text-primary mr-2" style={{ fontSize: "1.1rem", lineHeight: "1" }}>•</span>
                            <div>
                                <strong>Ασφάλεια αρχείου:</strong> Ορίστε ως κωδικό πρόσβασης (Password) για το κλείδωμα και την αποσυμπίεση του αρχείου μορφής .zip αποκλειστικά τον κωδικό: <strong>P800566476</strong>.
                            </div>
                        </li>
                        <li className="mb-3 d-flex align-items-start">
                            <span className="text-primary mr-2" style={{ fontSize: "1.1rem", lineHeight: "1" }}>•</span>
                            <div>
                                <strong>Προγραμματισμός αποστολής:</strong> Καθορίστε την επιθυμητή <strong>συχνότητα αποστολής</strong> του email (π.χ. ημερήσια ή όποτε σημειώνεται κίνηση του λογαριασμού), ανάλογα με τις ανάγκες της επιχείρησής σας.
                            </div>
                        </li>
                    </ul>

                    <div className="alert alert-danger mt-4 mb-0" style={{ fontSize: "0.9rem", lineHeight: "1.4" }}>
                        <strong>Προσοχή:</strong> Εάν το email ή ο κωδικός πρόσβασης <strong>δεν οριστούν σωστά</strong>, η αυτόματη ανάγνωση θα αποτύχει και <strong>οι συναλλαγές σας δεν θα εισαχθούν</strong> στο σύστημα.
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCloseInfo}>
                        ΟΚ
                    </Button>
                </Modal.Footer>
            </Modal>

        </React.Fragment>
    )
}

export default AccountingBankingTransactions;
